import Header from "../global/header";
import Footer from "../global/footer";
import Breadcrumbs from "../breadcrumbs";
import Authorv4 from "../authorv4.js";
import bookData from "../../data/bookpage.json";
import {useParams} from "react-router-dom";

const SingleBlog = ({headerv3, footer}) => {
  const {menuv2} = footer;
  const {slug} = useParams();
  const book = bookData.blog.blogList.find((b) => b.slug === slug);

  return (
    <>
      <Header header={headerv3} />
      <Breadcrumbs isBg="yes" title={book.title} />
      <Authorv4 isBg="" book={book} />
      <Footer isBg="yes" menu={menuv2} />
    </>
  );
};

export default SingleBlog;
